import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { Webhook } from 'lucide-react'
import { WebhooksScreen } from '@/screens/connect/SCR-039-webhooks'

const flag = z.preprocess(v => v === true || v === 1 || v === '1' || v === 'true', z.boolean())

export const Route = createFileRoute('/_app/connect/webhooks')({
  staticData: { screen: { id: 'SCR-039', title: 'Webhooks', group: 'Connect', perm: 'connector.manage', order: 7, description: 'Signed events sent to your systems when things change, with retries, a delivery log and redelivery.', icon: Webhook } },
  validateSearch: z.object({
    webhook: z.string().max(100).optional().catch(undefined),
    delivery: z.string().max(100).optional().catch(undefined),
    status: z.enum(['pending', 'sending', 'delivered', 'retrying', 'dead']).optional().catch(undefined),
    new: flag.optional().catch(undefined),
  }),
  component: WebhooksScreen,
})
